import dayjs        from 'dayjs';
import { computed } from 'mobx';
import FileModel    from './globals/FileModel';

export default class StandDocumentMediaModel extends FileModel {
  static get path() {
    return '/backend/stand_document_media/{?id}';
  }

  patch(attributes = {}, options = {}){
    return super.save({ ...options, patchAttributes: attributes });
  }

  save(options: any = {}): Promise<this> {
    return new Promise((resolve, reject) => {
      const formData = new FormData();

      Object.keys(this.attributes).forEach(key => {
        formData.set(key, this.attributes[key]);
      });

      return this.connector
        .save(this, { ...options, patchAttributes: formData })
        .then(result => {
          this.onSaveSuccess(result, options);
          resolve(this);
        })
        .catch(err => reject(err));
    });
  }

  @computed
  get objectUrl(): string {
    return this.get('objectUrl');
  }

  @computed
  get mediaFileName(): string {
    return this.get('mediaFileName');
  }

  @computed
  get stand(): string {
    return this.get('stand', '');
  }

  @computed
  get standDocumentMediaStatusId(): id {
    return this.get('standDocumentMediaStatus.id', '');
  }

  @computed
  get standDocumentMediaStatusReference(): string {
    return this.get('standDocumentMediaStatus.reference', '');
  }

  @computed
  get messageId(): id {
    return this.get('message.id', 0);
  }

  @computed
  get enabled(): boolean {
    return this.get('enabled', true);
  }

  @computed
  get messageCreatedByFirstName(): string {
    return this.get('message.createdByFirstName', '');
  }

  @computed
  get messageCreatedByLastName(): string {
    return this.get('message.createdByLastName', '');
  }

  @computed
  get messageUpdatedAtDate() {
    return dayjs(this.get('message.updatedAt'));
  }
}
